import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  DocumentoTipoRequisito,
  eEstadoDocumento,
  OtroDocumentoSecciones,
  SolicitudSeccion,
} from 'src/app/models/common/enumModel';
import { ConfiguracionDocumentoModel } from 'src/app/models/configuracion-documento/ConfiguracionDocumentoModel';
import { FilterConfiguracionDocumentoModel } from 'src/app/models/configuracion-documento/FilterConfiguracionDocumentoModel';
import { IConfiguracionDocumentoModel } from 'src/app/models/interfaces/configuracion-documento/IConfiguracionDocumentoModel';
import { IFilterConfiguracionDocumentoModel } from 'src/app/models/interfaces/configuracion-documento/IFilterConfiguracionDocumentoModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { DocumentacionRequeridaModel } from 'src/app/models/solicitud/DocumentacionRequeridaModel';
import { ConfiguracionDocumentoService } from 'src/app/services/configuracion-documento/configuracion-documento.service';

@Component({
  selector: 'app-adjuntar-tipo-documento-dialog',
  templateUrl: './adjuntar-tipo-documento-dialog.component.html',
  styleUrls: ['./adjuntar-tipo-documento-dialog.component.css'],
})
export class AdjuntarTipoDocumentoDialogComponent implements OnInit {
  modelList: IConfiguracionDocumentoModel[] =
    new Array<ConfiguracionDocumentoModel>();
  constructor(
    private configuracionDocumentoService: ConfiguracionDocumentoService,
    public dialogRef: MatDialogRef<AdjuntarTipoDocumentoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AdjuntarTipoDocumentoModel
  ) {}

  ngOnInit(): void {
    let filterConfigDocumentos = new FilterConfiguracionDocumentoModel();
    filterConfigDocumentos.idSeccion = this.data.idSeccion;
    filterConfigDocumentos.idEstado = eEstadoDocumento.ACTIVO;
    filterConfigDocumentos.idTipoVisita = this.data.idTipoVisita;
    // console.log(this.data);
    this.configuracionDocumentoService
      .getList(filterConfigDocumentos)
      .subscribe((resultConfigDocumentos) => {
        // console.log(resultConfigDocumentos);
        // console.log(this.data.listaTipoDocumentos);
        resultConfigDocumentos.forEach((item) => {
          if (item.idMaestroDocumento !== 1) {
            if (
              this.data.listaTipoDocumentos.findIndex(
                (p) =>
                  p.idConfiguracionDocumento == item.idConfiguracionDocumento
              ) == -1
            ) {
              this.modelList.push(item);
            }
          } else {
            this.modelList.push(item);
          }
        });
        let otroDocumento = new ConfiguracionDocumentoModel();
        otroDocumento.idConfiguracionDocumento = 0;
        otroDocumento.idMaestroDocumento = 1;
        otroDocumento.documento = "OTRO";
        otroDocumento.controlarFechas = false;
        otroDocumento.idRequisito = DocumentoTipoRequisito.ALGUNOS;

        this.modelList.push(otroDocumento);
      });
  }

  onChangeDocumento(item: any) {
    let config = this.modelList.find(
      (p) => p.idConfiguracionDocumento == item.value
    );
    if (config) {
      this.data.idMaestroDocumento = config.idMaestroDocumento;

      if (
        config.idMaestroDocumento !== 1
        //   OtroDocumentoSecciones.OTRO_DOCUMENTO_PERSONAL &&
        // this.data.idTipoDocumento !==
        //   OtroDocumentoSecciones.OTRO_DOCUMENTO_EQUIPO &&
        // this.data.idTipoDocumento !==
        //   OtroDocumentoSecciones.OTRO_DOCUMENTO_VEHICULO &&
        // this.data.idTipoDocumento !==
        //   OtroDocumentoSecciones.OTRO_DOCUMENTO_TECNICO
      ) {
        this.data.documento = '';
      }
    }
  }

  habilitarOtros(): boolean {
    return (
      this.data.idMaestroDocumento === 1 // OTROS
      //   OtroDocumentoSecciones.OTRO_DOCUMENTO_PERSONAL ||
      // this.data.idTipoDocumento ===
      //   OtroDocumentoSecciones.OTRO_DOCUMENTO_EQUIPO ||
      // this.data.idTipoDocumento ===
      //   OtroDocumentoSecciones.OTRO_DOCUMENTO_VEHICULO ||
      // this.data.idTipoDocumento ===
      //   OtroDocumentoSecciones.OTRO_DOCUMENTO_TECNICO
    );
  }

  EsValido(): boolean {
    if (
      this.data.idMaestroDocumento === 1 // OTRO
      //   OtroDocumentoSecciones.OTRO_DOCUMENTO_PERSONAL ||
      // this.data.idTipoDocumento ===
      //   OtroDocumentoSecciones.OTRO_DOCUMENTO_EQUIPO ||
      // this.data.idTipoDocumento ===
      //   OtroDocumentoSecciones.OTRO_DOCUMENTO_VEHICULO ||
      // this.data.idTipoDocumento ===
      //   OtroDocumentoSecciones.OTRO_DOCUMENTO_TECNICO
    ) {
      return this.data.documento !== '';
    } else {
      return this.data.idConfiguracionDocumento > 0;
    }
  }

  onSaveClick(): void {
    let parametroDocumento = this.modelList.find(
      (p) => p.idConfiguracionDocumento == this.data.idConfiguracionDocumento
    );

    if (parametroDocumento) {
      this.data.controlarFechas = parametroDocumento.controlarFechas;
      this.data.idRequisito = parametroDocumento.idRequisito;

      if (
        parametroDocumento.idMaestroDocumento === 1 // OTRO
        //   OtroDocumentoSecciones.OTRO_DOCUMENTO_PERSONAL ||
        // this.data.idTipoDocumento ===
        //   OtroDocumentoSecciones.OTRO_DOCUMENTO_EQUIPO ||
        // this.data.idTipoDocumento ===
        //   OtroDocumentoSecciones.OTRO_DOCUMENTO_VEHICULO ||
        // this.data.idTipoDocumento ===
        //   OtroDocumentoSecciones.OTRO_DOCUMENTO_TECNICO
      ) {
        this.data.documento = `${parametroDocumento.documento} - ${this.data.documento}`;
      } else {
        this.data.documento = parametroDocumento.documento;
      }
    }
  }

  onCerrarClick(): void {
    this.dialogRef.close();
  }
}

export class AdjuntarTipoDocumentoModel {
  listaTipoDocumentos: DocumentacionRequeridaModel[];
  idConfiguracionDocumento: number;
  idMaestroDocumento: number;

  // idTipoDocumento: number;
  controlarFechas: boolean;
  documento: string;
  idRequisito: number;
  idSeccion?: SolicitudSeccion;
  idTipoVisita: number;

  constructor() {
    this.idConfiguracionDocumento = -1;
    this.idMaestroDocumento = 0;

    // this.idTipoDocumento = 0;
    this.documento = '';
    this.controlarFechas = false;
    this.listaTipoDocumentos = new Array<DocumentacionRequeridaModel>();
    this.idRequisito = 0;
    this.idTipoVisita = 0;
  }
}
